import { render, staticRenderFns } from "./AsignacionNoSeriado.vue?vue&type=template&id=745957f1&"
import script from "./AsignacionNoSeriado.vue?vue&type=script&lang=ts&"
export * from "./AsignacionNoSeriado.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionNoSeriado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports